<header>
  <div class="logo no-print">
    <ng-container *ngIf="!isGestionReclamo; else noLink">
      <a href="consulta-padron">
        <img src="assets/images/logo-pj.png" alt="Logo">
      </a>
    </ng-container>
    <ng-template #noLink>
      <span>
        <img src="assets/images/logo-pj.png" alt="Logo">
      </span>
    </ng-template>
  </div>
</header>
